module.exports = require("html-webpack-plugin");


//////////////////
// WEBPACK FOOTER
// external "html-webpack-plugin"
// module id = 39
// module chunks = 0